import React from 'react';
import Button from '../../../../muiComponents/Button';
import useTranslate from '../../../../customHooks/useTranslate';
import { useNotification } from '../../../../contexts/NotificationsContext';
import { acceptConnectionToMember } from '../../../../services/zinantis/members/zinantisMemberListServices';
import { FeedbackMessages } from '../../../../utils/commonVariables/messages';
import { IZinantisConnectionRequest } from '../../../../types/entities/IZinantisConnectionRequest';

interface IAcceptConnectionButtonProps {
    onChangeLoading: (isLoading: boolean) => void;
    onRequestSuccess: (newRequest: IZinantisConnectionRequest) => Promise<void>;
    idRequest: number | string;
}

const AcceptConnectionButton = (props: IAcceptConnectionButtonProps) => {
    const { onChangeLoading, onRequestSuccess, idRequest } = props;
    const { setErrorMessage, setSuccessMessage } = useNotification();

    const translate = useTranslate();

    const handleAcceptConnection = async () => {
        try {
            onChangeLoading(true);
            const { data } = await acceptConnectionToMember(idRequest);
            if (data.Success && data.StatusCode === 200) {
                await onRequestSuccess(data.Result);
                setSuccessMessage(
                    FeedbackMessages.SUCCESSFUL_CONNECTION_REQUEST_ACCEPTED
                );
            } else {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            }
        } catch (error) {
            console.log({ error });
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
        } finally {
            onChangeLoading(false);
        }
    };

    return (
        <Button
            startIcon='Link'
            variant='contained'
            className='white-space-nowrap'
            style={{ height: '30px' }}
            onClick={handleAcceptConnection}
        >
            {translate('accept')}
        </Button>
    );
};

export default AcceptConnectionButton;
